module.exports = __webpack_public_path__ + "static/img/main_logo.svg";